import { Instance } from 'mobx-state-tree'
import { PlayerStatsModelBase } from './PlayerStatsModel.base'

/* The TypeScript type of an instance of PlayerStatsModel */
export interface PlayerStatsModelType extends Instance<typeof PlayerStatsModel.Type> {}

/* A graphql query fragment builders for PlayerStatsModel */
export { selectFromPlayerStats, playerStatsModelPrimitives, PlayerStatsModelSelector } from './PlayerStatsModel.base'

/**
 * PlayerStatsModel
 */
export const PlayerStatsModel = PlayerStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
